import { FormControl, Input, ListItemText, MenuItem, Checkbox } from '@material-ui/core';
import React from 'react';
import Select from '@mui/material/Select';
import { makeStyles } from '@material-ui/styles';
import Theme from '../ui/Theme';
export const useStyles = makeStyles(() => ({
  textfield: (props) => ({
    backgroundColor: Theme.palette.secondary.main,
    height: props.height,
    width: props.width,
    marginBottom: props.marginBottom,
    padding: '12px 12px 12px 12px',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '21px',
    ...(props.showMargin ? { marginTop: '12px' } : {}),
  }),
}));

const PopupMultiDropDown = (props) => {
  const styleProps = {
    width: props.width,
    height: props.height,
    marginBottom: props.marginBottom,
  };

  const classes = useStyles({ ...styleProps, showMargin: props.showMargin ?? true });
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const dropdownListItems = () => {
    const items = [];
    props.list?.forEach((option) => {
      items.push(
        <MenuItem
          key={`${option.id}-${option.title || option.name}`}
          name={option.id}
          value={option.title ? option.title : option.name}
        >
          <Checkbox color="primary" checked={props.mainArr?.some((el) => el?.id === option.id)} />
          <ListItemText primary={option.title ? option.title : option.name} />
        </MenuItem>,
      );
    });
    return items;
  };
  return (
    <FormControl>
      <Select
        name={props.name}
        labelId="demo-multiple-checkbox-label"
        id="demo-multiple-checkbox"
        value={props.value || []}
        onChange={props.handleChange}
        input={<Input disableUnderline className={classes.textfield} />}
        displayEmpty
        renderValue={(value) => {
          if (props.placeHolder) {
            return value?.length && Array.isArray(value)
              ? `${props.placeHolder} - ${value.join(', ')}`
              : props.placeHolder;
          }
          if (props.allowSelectAll) {
            if (value.length && Array.isArray(value)) {
              return value.length === props.filter?.length ? 'All' : `${value.join(', ')}`;
            }
          }
          return value.join(', ');
        }}
        MenuProps={MenuProps}
        multiple
      >
        {props.allowSelectAll && (
          <MenuItem key="all" name="all" value="all" onChange={props.handleAllPipelineStatus}>
            <Checkbox color="primary" checked={props.mainArr?.length === props.filter?.length} />
            <ListItemText primary="All" />
          </MenuItem>
        )}
        {dropdownListItems()}
      </Select>
    </FormControl>
  );
};

export default PopupMultiDropDown;
